$wj([78],{

/***/ 2579:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MailListItemExpansion_1 = __webpack_require__(5991);
exports.MailListItemExpansion = MailListItemExpansion_1.default;
//# sourceMappingURL=lazyIndex.js.map

/***/ }),

/***/ 2917:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Store_1 = __webpack_require__(17);
var getUserConfiguration_1 = __webpack_require__(9);
var doesFolderIdEqualName_1 = __webpack_require__(682);
var owa_trace_1 = __webpack_require__(14);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
function isLocalAvailableForSelectedNode() {
    var selectedNode = owa_mail_folder_forest_store_1.getSelectedNode();
    if (selectedNode.type == 2 /* Group */) {
        return true;
    }
    return !owa_mail_folder_forest_store_1.getFolderIdForSelectedNode();
}
/**
 * @returns [item to load based on selected folder, whether item is local, whether item is deleted].
 */
function findItemToLoad(conversationNode) {
    var itemCount = conversationNode && conversationNode.itemIds ? conversationNode.itemIds.length : 0;
    if (itemCount == 0) {
        return [null, false, false];
    }
    var foundItem = null;
    // If selected folder doesn't exist, treat item as a local item.
    var isLocal = isLocalAvailableForSelectedNode();
    var isDeleted = false;
    if (itemCount == 1) {
        foundItem = Store_1.default.items.get(conversationNode.itemIds[0]);
        if (!checkIfItemExists(conversationNode.itemIds[0], foundItem)) {
            return [null, false, false];
        }
        isLocal =
            isLocal ||
                (foundItem.ParentFolderId &&
                    foundItem.ParentFolderId.Id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode());
    }
    else {
        var sentItem = null;
        for (var _i = 0, _a = conversationNode.itemIds; _i < _a.length; _i++) {
            var itemId = _a[_i];
            var item = Store_1.default.items.get(itemId);
            if (!checkIfItemExists(itemId, item)) {
                return [null, false, false];
            }
            if (item.ParentFolderId && item.ParentFolderId.Id == owa_mail_folder_forest_store_1.getFolderIdForSelectedNode()) {
                foundItem = item;
                isLocal = true;
                break;
            }
            else if (doesFolderIdEqualName_1.default(item.ParentFolderId.Id, 'sentitems')) {
                sentItem = item;
            }
        }
        if (!foundItem) {
            foundItem = sentItem || Store_1.default.items.get(conversationNode.itemIds[0]);
        }
    }
    isDeleted = doesFolderIdEqualName_1.default(foundItem.ParentFolderId.Id, 'deleteditems');
    return [foundItem, isLocal, isDeleted];
}
exports.findItemToLoad = findItemToLoad;
function checkIfItemExists(itemId, item) {
    if (!itemId) {
        owa_trace_1.trace.error('ItemId in conversationNode.itemIds should not be:' + itemId);
        return false;
    }
    if (!item) {
        owa_trace_1.trace.error('Item should be in mailStore but does not exist.');
        return false;
    }
    return true;
}
function shouldCreateItemPartViewState(item, isDeleted, isLocal) {
    var userConfiguration = getUserConfiguration_1.default();
    var shouldHideDeletedItems = userConfiguration.UserOptions.HideDeletedItems;
    // No need to create view state for deleted drafts except for delete folder.
    // No need to create view state for deleted items when user setting has HideDeletedItems except for delete folder.
    return item && !((item.IsDraft || shouldHideDeletedItems) && isDeleted && !isLocal);
}
exports.shouldCreateItemPartViewState = shouldCreateItemPartViewState;
function getItemFromNodeId(nodeId) {
    var conversationNode = Store_1.default.conversationNodes.get(nodeId);
    var _a = findItemToLoad(conversationNode), item = _a[0], isLocal = _a[1], isDeleted = _a[2];
    if (!shouldCreateItemPartViewState(item, isDeleted, isLocal)) {
        return null;
    }
    else {
        return item;
    }
}
exports.getItemFromNodeId = getItemFromNodeId;
//# sourceMappingURL=conversationsUtils.js.map

/***/ }),

/***/ 5991:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var mobx_react_1 = __webpack_require__(11);
var owa_mail_folder_forest_store_1 = __webpack_require__(53);
var Store_1 = __webpack_require__(25);
var owa_mail_module_orchestrator_1 = __webpack_require__(99);
var owa_mail_reading_pane_store_1 = __webpack_require__(55);
var MailListItemSelectionSource_1 = __webpack_require__(42);
var Store_2 = __webpack_require__(17);
var conversationsUtils_1 = __webpack_require__(2917);
var getFormattedDate_1 = __webpack_require__(2218);
var owa_mail_strings_1 = __webpack_require__(22);
var React = __webpack_require__(3);
var styles = __webpack_require__(5992);
var classNames = __webpack_require__(30);
var MailListItemExpansion = /** @class */ (function (_super) {
    tslib_1.__extends(MailListItemExpansion, _super);
    function MailListItemExpansion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderItemPart = function (nodeId) {
            var item = conversationsUtils_1.getItemFromNodeId(nodeId);
            var senderName;
            var timeText;
            var parentFolder;
            var itemPartClasses;
            var itemPartContentClasses;
            var senderClasses;
            if (item) {
                senderName = item.From && item.From.Mailbox && item.From.Mailbox.Name;
                parentFolder = Store_2.default.folders.folderTable.get(item.ParentFolderId.Id);
                timeText =
                    !parentFolder || owa_mail_folder_forest_store_1.getFolderIdForSelectedNode() == parentFolder.FolderId.Id
                        ? getFormattedDate_1.default(item.DateTimeReceived)
                        : parentFolder.DisplayName;
                itemPartClasses = classNames(styles.itemPart, !item.IsRead && styles.unread);
                itemPartContentClasses = classNames(_this.props.isSingleLine
                    ? styles.itemPartContentSingleLine
                    : styles.itemPartContentThreeColumn, item.IsDraft && styles.itemPartContentDraft);
                senderClasses = classNames(!item.IsRead ? styles.senderUnread : styles.sender, item.IsDraft && styles.draft);
            }
            return (item && (React.createElement("div", { key: item.ItemId.Id, className: itemPartClasses, onClick: function () {
                    _this.onItemPartClicked(item.ItemId.Id);
                } },
                React.createElement("div", { className: itemPartContentClasses },
                    React.createElement("span", { className: senderClasses }, item.IsDraft ? owa_mail_strings_1.default.draftSenderPersonaPlaceholder : senderName),
                    React.createElement("span", { className: styles.time }, timeText)))));
        };
        return _this;
    }
    MailListItemExpansion.prototype.render = function () {
        var conversationItem = Store_1.default.conversationItems.get(this.props.conversationId);
        var displayItemParts = conversationItem.globalItemIds.length > 1;
        var conversationItemParts = Store_2.default.conversations.get(conversationItem.id);
        return (displayItemParts && (React.createElement("div", { className: styles.expansionContainer }, conversationItemParts &&
            conversationItemParts.conversationNodeIds.length > 0 &&
            conversationItemParts.conversationNodeIds.map(this.renderItemPart))));
    };
    MailListItemExpansion.prototype.onItemPartClicked = function (itemId) {
        var tableView = Store_1.default.tableViews.get(this.props.tableViewId);
        owa_mail_module_orchestrator_1.onListViewSelectionChange(tableView, true /* isUserNavigation */, MailListItemSelectionSource_1.default.MailListItemExpansion);
        owa_mail_reading_pane_store_1.lazySetItemIdToScrollTo.importAndExecute(itemId);
    };
    MailListItemExpansion = tslib_1.__decorate([
        mobx_react_1.observer
    ], MailListItemExpansion);
    return MailListItemExpansion;
}(React.Component));
exports.default = MailListItemExpansion;
//# sourceMappingURL=MailListItemExpansion.js.map

/***/ }),

/***/ 5992:
/***/ (function(module, exports, __webpack_require__) {

var content = __webpack_require__(5993);
var loader = __webpack_require__(8);

if(typeof content === "string") content = [[module.i, content]];

// add the styles to the DOM
for (var i = 0; i < content.length; i++) loader.loadStyles(content[i][1], false);

if(content.locals) module.exports = content.locals;

/***/ }),

/***/ 5993:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(16)(undefined);
// imports


// module
exports.push([module.i, "html[dir] ._2Jr9JdyL0La7bsRXqilY-s{background-color:\"[theme:themeLight, default:#C7E0F4]\"}._3RcbLH3u-vwvtKJqs7qcx4{display:-webkit-box;display:-ms-flexbox;display:flex;height:40px}html[dir] ._3RcbLH3u-vwvtKJqs7qcx4{background-color:\"[theme:themeLight, default:#C7E0F4]\";margin-bottom:1px}html[dir=ltr] ._3RcbLH3u-vwvtKJqs7qcx4{border-left-width:4px;border-left-style:solid;border-left-color:transparent}html[dir=rtl] ._3RcbLH3u-vwvtKJqs7qcx4{border-right-width:4px;border-right-style:solid;border-right-color:transparent}html[dir] ._3RcbLH3u-vwvtKJqs7qcx4:hover{background-color:\"[theme:neutralLight, default:#eaeaea]\"}html[dir=ltr] ._3RcbLH3u-vwvtKJqs7qcx4._3Si6d7mM4OaeMLVrMCnysb{border-left-color:\"[theme:themePrimary, default:#0078D7]\"}html[dir=rtl] ._3RcbLH3u-vwvtKJqs7qcx4._3Si6d7mM4OaeMLVrMCnysb{border-right-color:\"[theme:themePrimary, default:#0078D7]\"}._1MvbCNZAD2waF2JTnZhEtI,._1RowrP1RfcTAPFhZmeH57v,._226GXtyjQcoWZD-JjLCL1N{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between;overflow:hidden}html[dir] ._1MvbCNZAD2waF2JTnZhEtI,html[dir] ._1RowrP1RfcTAPFhZmeH57v,html[dir] ._226GXtyjQcoWZD-JjLCL1N{border-top-width:1px;border-top-style:solid;border-top-color:\"[theme:themeTertiary, default:#71AFE5]\"}html[dir=ltr] ._1MvbCNZAD2waF2JTnZhEtI,html[dir=ltr] ._1RowrP1RfcTAPFhZmeH57v,html[dir=ltr] ._226GXtyjQcoWZD-JjLCL1N{padding-right:24px}html[dir=rtl] ._1MvbCNZAD2waF2JTnZhEtI,html[dir=rtl] ._1RowrP1RfcTAPFhZmeH57v,html[dir=rtl] ._226GXtyjQcoWZD-JjLCL1N{padding-left:24px}html[dir=ltr] ._1RowrP1RfcTAPFhZmeH57v{margin-left:68px}html[dir=rtl] ._1RowrP1RfcTAPFhZmeH57v{margin-right:68px}html[dir=ltr] ._226GXtyjQcoWZD-JjLCL1N{margin-left:48px}html[dir=rtl] ._226GXtyjQcoWZD-JjLCL1N{margin-right:48px}._1YtFe491q8RQUWJzq-lLoc,.PXIbwxzZmk9fFzxSVC3H0{font-size:14px;font-weight:400;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}._1YtFe491q8RQUWJzq-lLoc{font-weight:600}._1TrTfcATzQQcDqaAQiWL6D{color:\"[theme:neutralSecondary, default:#666666]\";font-size:12px;font-weight:400;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}html[dir=ltr] ._1TrTfcATzQQcDqaAQiWL6D{padding-left:16px}html[dir=rtl] ._1TrTfcATzQQcDqaAQiWL6D{padding-right:16px}.eiLJAkKb70uLQfQlSSppk{color:#d83b01}", ""]);

// exports
exports.locals = {
	"expansionContainer": "_2Jr9JdyL0La7bsRXqilY-s",
	"itemPart": "_3RcbLH3u-vwvtKJqs7qcx4",
	"unread": "_3Si6d7mM4OaeMLVrMCnysb",
	"itemPartContent": "_1MvbCNZAD2waF2JTnZhEtI",
	"itemPartContentSingleLine": "_1RowrP1RfcTAPFhZmeH57v",
	"itemPartContentThreeColumn": "_226GXtyjQcoWZD-JjLCL1N",
	"sender": "PXIbwxzZmk9fFzxSVC3H0",
	"senderUnread": "_1YtFe491q8RQUWJzq-lLoc",
	"time": "_1TrTfcATzQQcDqaAQiWL6D",
	"itemPartContentDraft": "eiLJAkKb70uLQfQlSSppk"
};

/***/ })

});


// WEBPACK FOOTER //
// owa.MailListItemExpansion.js